import { generatePath, matchPath } from 'react-router-dom';
import { Funnelable, Funnel } from '../types';

export class ReleasesLocations implements Funnelable {
  routeSegment = 'releases';

  funnels = [Funnel.RELEASES];

  pathname = `/${this.routeSegment}`;

  all = {
    pathname: () => generatePath(`/${this.pathname}/${this.all.route}`),
    route: 'all',
  };

  draft = {
    pathname: () => generatePath(`/${this.pathname}/${this.draft.route}`),
    route: 'draft',
  };

  pending = {
    pathname: () => generatePath(`/${this.pathname}/${this.pending.route}`),
    route: 'pending',
  };

  released = {
    pathname: () => generatePath(`/${this.pathname}/${this.released.route}`),
    route: 'released',
  };

  funnelsForPathname(pathname: string) {
    if (matchPath(`${this.routeSegment}/*`, pathname)) return this.funnels;
    return null;
  }
}
